let x = 0;
let y = 0;

export const setMouse = (newX, newY) => {
    x = newX;
    y = newY;
};

export const getMouse = () => [x, y];
